import * as React from 'react';


function HistoricalFinancialsTable({financialReport, metricsDictionary, numberOfYears} :any) {

  function HistoricalFinancialsTableRow({financialReport, metric} :any) {

    function displayableRow(financialReport, metric) : Boolean {

      const everyMetricIsNull = financialReport.every(item => ((columnValue(item, metric) == null) &&  (columnValue(item, metric) == undefined)))
      return (everyMetricIsNull ? false : true)
    }

    function columnValue(report, metric) {
      return (metric.useHumanValue ? report[metric.columnName]?.human_value : report[metric.columnName])
    }
    if (displayableRow(financialReport, metric)) {
      return (
        <tr>
          <td width="10%" className="financials-table__metric"><strong>{metric.displayName}</strong></td>
          {financialReport?.map((item => (
            <td key={`${metric.columnName}-${item.year}`} className={ item[metric.className] }>{columnValue(item, metric)}</td>
          )))}
        </tr>
      )
    } else {
      return(<span/>)
    }
  }

  function years() : Array<Number>  {
    return financialReport.map((report => report.year))
  }

  return (
    <table className="table table-hover table-bordered table-sm financials-table">
      <thead>
        <tr>
          <th className="financials-table__corner"><strong></strong></th>
          {years().map((year => (
            <th key={year.toString()} className="financials-table__year"><strong>{year}</strong></th>
          )))}
        </tr>
      </thead>
      <tbody>
        {metricsDictionary.map((metric =>
          <HistoricalFinancialsTableRow
            key={metric.columnName}
            financialReport={financialReport}
            metric={metric}
          />
        ))}
      </tbody>
    </table>
  );
}

export default HistoricalFinancialsTable;
